/* Copyright (c) 2025 Xperi. All Rights Reserved. */

import React, { FunctionComponent } from 'react';

import { RecordingRestriction } from '../../../core/usecases';
import { RestrictionMessageProps } from './RestrictionMessageProps';

import './RestrictionMessage.scss';

const RestrictionMessage: FunctionComponent<RestrictionMessageProps> = ({
    channel,
    displayType,
    programCell,
    preview,
}) => {
    const restrictionDetails = RecordingRestriction.getRestrictionDetails(
        displayType,
        channel,
        programCell,
        preview,
    );
    const displayRestriction = restrictionDetails.isRestricted && (
        <div className={displayType}>{restrictionDetails.message}</div>
    );

    return <React.Fragment>{displayRestriction}</React.Fragment>;
};

export default RestrictionMessage;
